import { store$ } from '@redux/store';
import { map, distinctUntilChanged, skip } from 'rxjs';
import { selectLocationType, LocationType } from 'features/searchResultsFacets';

const stateFooter = document.querySelector('[data-state-search-results-footer-container]');
const defaultFooter = document.querySelector('[data-search-results-footer-container]');

const onLocationTypeChange$ = store$.pipe(
  map(selectLocationType),
  distinctUntilChanged(),
  skip(1)
);

/**
 * toggleFooter: Shows the state footer or default footer based on location type.
 * @param {string} locationType The current location type.
 */
const toggleFooter = (locationType) => {
  const isLocationTypeState = locationType === LocationType.State.toString();
  stateFooter.hidden = !isLocationTypeState;
  defaultFooter.hidden = isLocationTypeState;
};

onLocationTypeChange$.subscribe(toggleFooter);